import React from 'react';
import { MenuInput } from './SizeAndPositionButtons';
import { updateCurrentSlideThumbnail, updateNonRectangularShape } from '../../actions/CurrentSlideActions';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from '../../locales/LocalesManager';
import storeManager from '../../store/StoreManager';
import shapeConstants from '../../constants/ShapeConstants';
import { connect } from "react-redux";

const PositionViewLineAndCurveContent = React.createClass({
    getInitialState() {
        const shapeModel = this.getContextTarget();

        if (shapeModel.type === shapeConstants.CURVE) {
            return {
                type: shapeModel.type,
                x1: shapeModel.x1,
                y1: shapeModel.y1,
                x2: shapeModel.x2,
                y2: shapeModel.y2,
                cx: shapeModel.cx,
                cy: shapeModel.cy
            };
        } else {
            return {
                type: shapeModel.type,
                x1: shapeModel.x1,
                y1: shapeModel.y1,
                x2: shapeModel.x2,
                y2: shapeModel.y2
            };
        }
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
            var contextTarget = this.getContextTarget();

            if (this.state.type === shapeConstants.CURVE)
                this.setState({x1: contextTarget.x1, y1: contextTarget.y1, x2: contextTarget.x2, y2: contextTarget.y2, cx: contextTarget.cx, cy: contextTarget.cy});
            else
                this.setState({x1: contextTarget.x1, y1: contextTarget.y1, x2: contextTarget.x2, y2: contextTarget.y2});
        }
    },
    getContextTarget() {
        const shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.shapeModel.uuid)
                return shapes[i];
        }

        return this.props.shapeModel;
    },
    changePosition(name, value) {
        const shapeModel = this.getContextTarget();

        if (!shapeModel)
            return;

        value = parseInt(value) || 0;
        let isChanged = false;

        switch (name) {
            case 'x1': { // x1
                if (shapeModel.x1 != value) {
                    isChanged = true;
                    this.setState({x1: value});
                    this.props.dispatch(updateNonRectangularShape(shapeModel.uuid, value, shapeModel.y1, shapeModel.x2, shapeModel.y2, shapeModel.cx, shapeModel.cy));
                }
                break;
            }
            case 'y1': { // y1
                if (shapeModel.y1 != value) {
                    isChanged = true;
                    this.setState({y1: value});
                    this.props.dispatch(updateNonRectangularShape(shapeModel.uuid, shapeModel.x1, value, shapeModel.x2, shapeModel.y2, shapeModel.cx, shapeModel.cy));
                }
                break;
            }
            case 'x2': { // x2
                if (shapeModel.x2 != value) {
                    isChanged = true;
                    this.setState({x2: value});
                    this.props.dispatch(updateNonRectangularShape(shapeModel.uuid, shapeModel.x1, shapeModel.y1, value, shapeModel.y2, shapeModel.cx, shapeModel.cy));
                }
                break;
            }
            case 'y2': { // y2
                if (shapeModel.y2 != value) {
                    isChanged = true;
                    this.setState({y2: value});
                    this.props.dispatch(updateNonRectangularShape(shapeModel.uuid, shapeModel.x1, shapeModel.y1, shapeModel.x2, value, shapeModel.cx, shapeModel.cy));
                }
                break;
            }
            case 'cx': { // cx
                if (shapeModel.cx != value) {
                    isChanged = true;
                    this.setState({cx: value});
                    this.props.dispatch(updateNonRectangularShape(shapeModel.uuid, shapeModel.x1, shapeModel.y1, shapeModel.x2, shapeModel.y2, value, shapeModel.cy));
                }
                break;
            }
            case 'cy': { // cy
                if (shapeModel.cy != value) {
                    isChanged = true;
                    this.setState({cy: value});
                    this.props.dispatch(updateNonRectangularShape(shapeModel.uuid, shapeModel.x1, shapeModel.y1, shapeModel.x2, shapeModel.y2, shapeModel.cx, value));
                }
                break;
            }
        }

        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    render() {
        const smallTextStyle = {
            fontSize: '12px',
            marginTop: '15px',
            marginBottom: '-5px'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        var idValue1;
        var idValue2;

        if (this.state.type === shapeConstants.CURVE) {
            idValue2 = "resizeLastItem";
        } else
            idValue1 = "resizeLastItem";

        return (
            <div>
                <h3 style={smallTextStyle}>{locales.getCaption('StartPoint', 'sizePosMenu')}</h3>

                <div style={buttonWrapperStyle}>
                    <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.x1} property={'x1'} onChangeHandler={this.changePosition}/>
                    <MenuInput isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.y1} property={'y1'} onChangeHandler={this.changePosition}/>
                </div>

                <h3 style={smallTextStyle}>{locales.getCaption('EndPoint', 'sizePosMenu')}</h3>

                <div style={buttonWrapperStyle}>
                    <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.x2} property={'x2'} onChangeHandler={this.changePosition}/>
                    <MenuInput id={idValue1} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.y2} property={'y2'} onChangeHandler={this.changePosition}/>
                </div>

                {
                    this.state.type === shapeConstants.CURVE ?
                        <div>
                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu')}</h3>

                            <div style={buttonWrapperStyle}>
                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx} property={'cx'} onChangeHandler={this.changePosition}/>
                                <MenuInput id={idValue2} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy} property={'cy'} onChangeHandler={this.changePosition}/>
                            </div>
                        </div>
                        : null
                }
            </div>
        )
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var refreshShapePosition = state.menu.refreshShapePosition;

    return {
        refreshShapePosition
    };
}

export const PositionViewLineAndCurve = connect(mapStateToProps)(PositionViewLineAndCurveContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/PositionViewLineAndCurve.js
 **/